import { cn } from "@/lib/utils";

/**
 * Small red count bubble for nav/icon badges (Inbox unread, notifications).
 * Renders nothing when count <= 0 and caps the display at 99+. Position it by
 * passing an `absolute …` className over a `relative` parent.
 */
export function CountBadge({
  count,
  className,
}: {
  count: number;
  className?: string;
}) {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        "flex items-center justify-center min-w-[14px] h-[14px] px-1 rounded-full bg-destructive text-[9px] font-bold leading-none text-white ring-2 ring-background",
        className,
      )}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
